import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
import { PendingHabitIcon } from './PendingHabits';
import { Button } from './ui/Button';
import { Modal } from './ui/Modal';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';

/**
 * ⓘ trigger + explanation sheet for the Life Score. Reused on Home and on
 * Life Score Detail so the explanation is written once.
 */
export function LifeScoreInfo({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const {
    t
  } = useLocale();
  const {
    habits
  } = useProgress();
  const [open, setOpen] = useState(false);
  return <>
      <button type="button" onClick={() => setOpen(true)} aria-label={t('home.summary.info')} className={`grid h-11 w-11 shrink-0 place-items-center rounded-pill transition-colors duration-150 ease-brand ${tone === 'dark' ? 'text-ondark hover:text-gold' : 'text-muted hover:text-deep'}`} data-id="element-823" data-mp="368zktd5xzq64">
        <InfoIcon size={17} data-id="element-824" data-mp="1lbhappj11sm9" />
      </button>

      <Modal open={open} onClose={() => setOpen(false)} labelledBy="lsinfo-title" data-id="element-825" data-mp="1l8cwdzbulghv">
        <div className="max-h-[70vh] overflow-y-auto px-1 pb-1 pt-2" data-id="element-826" data-mp="1q8r7jq8qx6k4">
          <h2 id="lsinfo-title" className="pr-10 text-title text-deep" data-id="element-827" data-mp="1bb8b01pttp24">
            {t('lsinfo.title')}
          </h2>
          <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-828" data-mp="1g9ryi6k2j8wl">
            {t('lsinfo.body')}
          </p>

          <h3 className="mt-3 text-[12.5px] font-bold text-deep" data-id="element-829" data-mp="12hv8q95vhb3d">{t('lsinfo.areas')}</h3>
          <ul className="mt-1 grid grid-cols-2 gap-1" data-id="element-830" data-mp="17bzguvqvjp61">
            {habits.map(habit => <li key={habit.id} className="flex min-h-[40px] items-center gap-1 rounded-card border border-sand-line bg-white/70 px-2 text-[12.5px] font-medium text-deep" data-id="element-831" data-mp="snbpz2rz43mf">
                <span className="text-soft" aria-hidden="true" data-id="element-832" data-mp="jn6qdet0u9it">
                  <PendingHabitIcon name={habit.icon} data-id="element-833" data-mp="nldzpol5o8jz" />
                </span>
                <span className="truncate" data-id="element-834" data-mp="2q9m8nebd7b3q">{t(`habit.${habit.id}.title`)}</span>
              </li>)}
          </ul>

          <h3 className="mt-3 text-[12.5px] font-bold text-deep" data-id="element-835" data-mp="2lh1jwr7bfo72">{t('lsinfo.periods')}</h3>
          <p className="mt-[2px] text-[12.5px] leading-relaxed text-muted" data-id="element-836" data-mp="2gkb5s9f2n2oa">
            {t('lsinfo.periodsBody')}
          </p>

          <p className="mt-2 text-[12.5px] leading-relaxed text-deep" data-id="element-837" data-mp="2bideqt0fj3ks">{t('lsinfo.nectar')}</p>
          <p className="mt-2 border-t border-sand-line pt-2 text-[11.5px] leading-snug text-muted" data-id="element-838" data-mp="397fb6fi2tj0l">
            {t('lsinfo.disclaimer')}
          </p>

          <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={() => setOpen(false)} data-id="element-839" data-mp="2z99dyb77t122">
            {t('lsinfo.close')}
          </Button>
        </div>
      </Modal>
    </>;
}